/**
 * Strips HTML tags from rich-text note content for use in plain-text
 * previews (list rows, search results, etc). The full formatted content is
 * only rendered as HTML inside NoteOverlay's contentEditable editor.
 */
export function stripHtml(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;

  // Remove delete-button glyphs so they never leak into previews.
  div.querySelectorAll(".link-delete-btn").forEach((el) => el.remove());

  // Give bookmark/embed blocks a short, friendly placeholder instead of
  // their raw inner markup (which otherwise glues together with no
  // separators, or shows nothing at all for a videoless-text iframe).
  div.querySelectorAll("[data-link-block]").forEach((el) => {
    const isVideo = el.hasAttribute("data-url");
    const href = el.getAttribute("data-href");
    el.textContent = isVideo ? "\u{1F4F9} Video" : "\u{1F517} " + (href || "Link");
  });

  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
}
